import type { SVGProps } from 'react';
const SvgChangeHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#change_history_svg__a)">
      <path
        fill="currentColor"
        d="M12 7.77 18.39 18H5.61L12 7.77ZM12 4 2 20h20L12 4Z"
      />
    </g>
    <defs>
      <clipPath id="change_history_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChangeHistory;
